import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { LoginService } from '../../services/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as sha512 from 'js-sha512';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  success = true;
  passEncryp = "";
  count: number = 0;
  @Input() loginData: {
    user: string,
    password: string,
  } = {
      user: "",
      password: ""
    };

  @Output() private changeLogin = new EventEmitter<number>();

  constructor(private navigationService: NavigationService,
    private loginService: LoginService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    if (!sessionStorage.getItem('foo')) {
      console.log("if", sessionStorage.getItem('foo'))
      sessionStorage.setItem('foo', 'no reload');
      // location.reload();
    }

    if(localStorage.getItem('token')){
      localStorage.clear()
    }

    this.registerForm = this.formBuilder.group({
      user: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  changeInput(field: string, value: any, type: string = ''): void {

    if (field == 'password') {
      // this.loginData[field] = sha512.sha512(value);
      this.passEncryp = value;
    }
    else this.loginData[field] = value;

  }
  get f() { return this.registerForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    this.loginData.password = this.passEncryp;
    let data  = {
      user: this.loginData.user,
      password:sha512.sha512(this.loginData.password)
    }
    console.log('Data Login')
    console.log(data)
    this.loginService.login(data).then((val) => {
      console.log(val)
      let objectJson = JSON.parse(val)
      let response = objectJson.data;
      console.log(response)
      if (response.usertableentity.status == true) {

        console.log("user entity status ", true)
        sessionStorage.setItem('batoken', response.token);
        sessionStorage.setItem('userid', response.usertableentity.userId);
        sessionStorage.setItem('loginData', JSON.stringify(response));
        sessionStorage.setItem('reglas', response.reglaTableEntity);
        localStorage.setItem('token', response.token)

        this.loginService.obtenerPermisosMenu('inicio').then((responseBody) => {
          console.log('Response Body')
          console.log(responseBody)
          if(responseBody.data.rolId == 3){
            this.navigationService.goTo('/dashboard-contratista');
          }else if (responseBody.data.rolId == 1 || responseBody.data.rolId == 2){
            this.navigationService.goTo('/dashboard');
          }
        })

      }
      else {
        this.success = false;
      }
    }
    ).catch((error) => {
      console.log("error login: " + error);
      this.success = false;
    });
  }

}
